/**
 * The one icon set, shared by the rail, the module panel and the login
 * picker. It used to live inside Sidebar.tsx, which meant the picker could
 * not draw a module without importing the navigation.
 *
 * Inline paths, no icon package - a dependency for fourteen shapes is a
 * dependency to keep patched for fourteen shapes.
 */
export const ICON: Record<string, string> = {
  sun: 'M10 3v2m0 10v2m7-7h-2M5 10H3m11.95-4.95l-1.41 1.41M6.46 13.54l-1.41 1.41m0-9.9l1.41 1.41m7.08 7.08l1.41 1.41M13 10a3 3 0 11-6 0 3 3 0 016 0z',
  list: 'M7 5h9M7 10h9M7 15h9M4 5h.01M4 10h.01M4 15h.01',
  check: 'M4 10.5l3.5 3.5L16 5.5',
  send: 'M3 10l14-6-6 14-2-6-6-2z',
  inbox: 'M3 11h4l1.5 3h3L13 11h4M3 11l2-6h10l2 6v5H3v-5z',
  star: 'M10 3l2.2 4.5 5 .7-3.6 3.5.85 5L10 14.3 5.55 16.7l.85-5L2.8 8.2l5-.7L10 3z',
  clock: 'M10 5.5V10l3 1.6M17 10a7 7 0 11-14 0 7 7 0 0114 0z',
  search: 'M13.5 13.5L17 17M15 9a6 6 0 11-12 0 6 6 0 0112 0z',
  people: 'M13 15v-1a3 3 0 00-3-3H6a3 3 0 00-3 3v1M8 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm9 7v-1a3 3 0 00-2.25-2.9M13 3.1A2.5 2.5 0 0113 8',
  bell: 'M8 16a2 2 0 004 0M5 8a5 5 0 0110 0c0 3.5 1.2 4.5 1.2 4.5H3.8S5 11.5 5 8z',
  cog: 'M10 13a3 3 0 100-6 3 3 0 000 6zM10 2v2m0 12v2M4.2 4.2l1.4 1.4m8.8 8.8l1.4 1.4M2 10h2m12 0h2M4.2 15.8l1.4-1.4m8.8-8.8l1.4-1.4',
  folder: 'M3 6a1 1 0 011-1h3.5l1.5 2H16a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V6z',
  calendar: 'M5 3v2m10-2v2M3.5 7.5h13M4 5h12a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1zM7 10.5h.01M10 10.5h.01M13 10.5h.01M7 13.5h.01M10 13.5h.01',
  logout: 'M8.5 3h-4a1 1 0 00-1 1v12a1 1 0 001 1h4M13 6.5L16.5 10 13 13.5M16 10H8',
  /** Creator - building the org's pieces. A set square and pencil. */
  tools: 'M3 16.5L6.5 3l4 4-1.5 5.5L3 16.5zM12 4.5l3.5 3.5M10.5 13l6-6a1.5 1.5 0 00-2-2l-6 6',
  /** Audit Trail - accountability, not a lock. A shield with a tick. */
  shield: 'M10 2.5l6 2v5c0 4-2.6 6.6-6 8-3.4-1.4-6-4-6-8v-5l6-2zM7.5 9.8l1.8 1.8 3.4-3.4',
};

export function ModuleIcon({
  name,
  className = 'h-4 w-4 shrink-0',
}: {
  name: string;
  className?: string;
}) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" className={className}>
      <path
        d={ICON[name] ?? ICON.list}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
